<template>
  <VRow v-if="isShowSection" class="vehicle-driver-info mt-0 pt-1">
    <VCol
      v-if="vehicleInfo"
      cols="12"
      lg="12"
      md="12"
      sm="12"
      xs="12"
      class="body-2 pb-0 pt-0"
    >
      <img
        :src="require(`@slg/web-customer-shared/src/assets/img/wheel.svg`)"
        class="mr-4"
        :alt="$t('imageAlt.vehicle')"
      />
      {{ vehicleInfo }}
    </VCol>
    <VCol
      v-if="trip.driverFirstName"
      cols="12"
      lg="12"
      md="12"
      sm="12"
      xs="12"
      class="body-2 pt-2"
    >
      <img
        :src="require(`@slg/web-customer-shared/src/assets/img/driver.svg`)"
        class="vehicle-driver-info__driver-image mr-4"
        :alt="$t('imageAlt.driver')"
      />
      <span v-if="trip.driverFirstName" class="mr-4">
        {{ trip.driverFirstName || "" }}
      </span>
    </VCol>
  </VRow>
</template>

<script lang="ts">
export default {
  name: 'VehicleDriverInfo',
};
</script>

<script setup lang="ts">
import { computed, watch } from 'vue';
import moment from 'moment';
import BookingStatusEnum from '@slg/web-customer-shared/src/enum/BookingStatusEnum';
import BookingStopTypeEnum from '@slg/web-customer-shared/src/enum/BookingStopTypeEnum';

const props = defineProps({
  trip: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['showDriverInfo']);

const vehicleInfo = computed(() => [
  props.trip.vehicleManufacture,
  props.trip.vehicleModel,
  props.trip.vehicleColor,
  props.trip.vehicleRegistrationPlate,
]
  .filter(Boolean)
  .join(', '));

const isShowSection = computed(() => {
  const hasInfo =
    vehicleInfo.value ||
    props.trip.driverPhoneNumber ||
    props.trip.driverFirstName;
  const validByStatus =
    props.trip.bookingStatus === BookingStatusEnum.ASSIGNED;
  const firstStop = props.trip.stops.find(
    ({ bookingStopType }: { bookingStopType: string }) =>
      bookingStopType === BookingStopTypeEnum.DEPARTURE_STOP
  );
  const validByTime = firstStop
    ? moment(firstStop.assumedArrivalTime || 0)
      .subtract(30, 'minutes')
      .valueOf() < moment().valueOf()
    : false;
  return hasInfo && validByStatus && validByTime;
});

watch(isShowSection, (newVal) => {
  emit('showDriverInfo', newVal);
}, { immediate: true });
</script>

<style lang="scss" scoped>
.vehicle-driver-info {
  &__driver-image {
    border-radius: 50%;
  }

  &__phone-icon {
    transform: scaleX(-1);
  }
}
</style>
